"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcaneGambleAbilityHandler = exports.ArcaneGambleActorAbilityFactory = exports.ArcaneGambleAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const MaxAttributeDecrease_1 = require("../../core/effects/core/MaxAttributeDecrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ArcaneGambleAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ArcaneGamble;
        this.__typeName = "ArcaneGamble";
    }
}
exports.ArcaneGambleAbilityArgs = ArcaneGambleAbilityArgs;
let ArcaneGambleActorAbilityFactory = class ArcaneGambleActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ArcaneGamble", "AllEnemies", 2);
    }
};
ArcaneGambleActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ArcaneGamble")
], ArcaneGambleActorAbilityFactory);
exports.ArcaneGambleActorAbilityFactory = ArcaneGambleActorAbilityFactory;
let ArcaneGambleAbilityHandler = class ArcaneGambleAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            attackType: "magic",
            projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => {
                return {
                    targetId,
                    path: "line",
                    type: "ShuffledCards",
                    damages: [
                        {
                            percent: 2,
                            power: 160
                        },
                        {
                            percent: 4,
                            power: 80
                        },
                        {
                            percent: 8,
                            power: 40,
                        },
                        {
                            percent: 16,
                            power: 20,
                        },
                        {
                            percent: 32,
                            power: 10
                        }
                    ]
                        .filter(({ percent }) => container.testAttribute(ability.invokerId, "Luck", percent))
                        .map(({ power }) => AbilityDamage_1.AbilityDamage.Focus("Chaos", power))
                };
            }),
            onHit(sequence, _attack, _damage, projectile) {
                if (container.testAttribute(ability.invokerId, "Luck", 20)) {
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: projectile.targetId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(AttributeType_1.AttributeType.ChaosDamageImmunity, 25),
                    });
                }
            }
        });
    }
};
ArcaneGambleAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ArcaneGamble)
], ArcaneGambleAbilityHandler);
exports.ArcaneGambleAbilityHandler = ArcaneGambleAbilityHandler;
